import { usePathname } from 'next/navigation';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import React, { useMemo } from 'react';
import { Button } from '@/DesignSystem/Component';
import { useLoggedIn } from '@/Module/Auth/Hook';
import { authSetIsTransitioningAction } from '@/Module/Auth/Store/Slice/AuthSlice';
import { LINKS } from '@/Module/Core/Constant';
import { useDeviceType } from '@/Module/Core/Hook';
import { DeviceType } from '@/Module/Core/Model/Enum';
import MiniAccountLoggedInDesktop from '@/Module/DefaultLayout/Component/MiniAccount/MiniAccountLoggedInDesktop';
import { useAppDispatch } from '@/Module/Store/Hook';
const MiniAccount: FC = () => {
  const dispatch = useAppDispatch();
  const isLoggedIn = useLoggedIn();
  const router = useRouter();
  const pathName = usePathname();
  const deviceType = useDeviceType();
  const queryString = useMemo(() => {
    if (!router.asPath || router.asPath?.includes('auth')) return '';
    return `?redirectUrl=${encodeURI(router.asPath)}`;
  }, [router.asPath]);
  return <div data-sentry-component="MiniAccount" data-sentry-source-file="MiniAccount.tsx">
      {isLoggedIn && !(deviceType === DeviceType.MOBILE) ? <MiniAccountLoggedInDesktop /> : <div className="hidden md:flex">
          <Button onClick={() => {
        dispatch(authSetIsTransitioningAction(true));
        router.push(`${LINKS.AUTH.LOGIN}${queryString}`);
      }} variant="contained" radius="circle" color="white" disabled={pathName === `${LINKS.AUTH.LOGIN}/` || pathName === `${LINKS.AUTH.CONFIRM}/`} className="relative z-50 min-w-[110px]" bold>
            ورود
          </Button>
        </div>}
    </div>;
};
export default MiniAccount;